module.exports = __webpack_public_path__ + "static/media/STABI S TURNTABLE.e532aa41.png";